(function () {
  if (window.__mxInit) return;
  window.__mxInit = true;
  var d = document, html = d.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var G = window.gsap, ST = window.ScrollTrigger;
  var hasG = !!(G && ST);
  var lenis = null;

  function ctx() {
    return { gsap: G, ST: ST, anim: hasG && !reduce, reduce: reduce, fine: fine, lenis: lenis, split: splitLines };
  }

  function splitLines(el) {
    if (window.SplitText) {
      var s = window.SplitText.create(el, { type: 'lines', mask: 'lines', linesClass: 'mx-sl' });
      return s.lines;
    }
    return [el];
  }

  function run(scope) {
    var reg = window.MXS || {};
    scope.querySelectorAll('[data-mx]').forEach(function (el) {
      if (el.__mxDone) return;
      var fn = reg[el.getAttribute('data-mx')];
      if (!fn) return;
      el.__mxDone = true;
      try { fn(el, ctx()); } catch (e) { console.warn('[mx]', el.getAttribute('data-mx'), e); }
    });
    if (hasG && !reduce) {
      scope.querySelectorAll('[data-mx-rise]').forEach(function (el) {
        if (el.__mxRise) return; el.__mxRise = true;
        G.from(el, { y: 50, autoAlpha: 0, duration: 1.1, ease: 'expo.out', delay: parseFloat(el.getAttribute('data-mx-rise')) || 0,
          scrollTrigger: { trigger: el, start: 'top 88%', once: true } });
      });
      scope.querySelectorAll('[data-mx-lines]').forEach(function (el) {
        if (el.__mxLines) return; el.__mxLines = true;
        var lines = splitLines(el);
        G.from(lines, { yPercent: 115, duration: 1.15, ease: 'expo.out', stagger: 0.09,
          scrollTrigger: { trigger: el, start: 'top 86%', once: true } });
      });
    }
  }

  function buy() {
    d.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mx-buy]');
      if (!b) return;
      e.preventDefault();
      var id = b.getAttribute('data-variant');
      if (!id) return;
      b.setAttribute('aria-busy', 'true');
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        window.location.href = root + 'checkout';
      }).catch(function () { window.location.href = '/cart/' + id + ':1'; });
    });
  }

  function scrollLinks() {
    d.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"], a[href^="/#"]');
      if (!a) return;
      var hash = a.getAttribute('href').replace(/^\//, '');
      if (hash.length < 2) return;
      var t = d.querySelector(hash);
      if (!t) return;
      e.preventDefault();
      if (lenis) lenis.scrollTo(t, { offset: -10, duration: 1.6 });
      else t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function sticky() {
    var bar = d.querySelector('.mx-sticky');
    if (!bar || !('IntersectionObserver' in window)) return;
    var hero = d.querySelector('[data-mx="hero"]');
    var blockers = [d.querySelector('featured-product-information'), d.querySelector('[data-mx="buy"]'), d.querySelector('footer'), d.querySelector('[data-mx="cta"]'), d.querySelector('[data-mx="how"]'), d.querySelector('[data-mx="drinks"]')].filter(Boolean);
    var past = !hero, vis = new Set();
    function upd() { bar.classList.toggle('is-on', past && vis.size === 0); }
    if (hero) new IntersectionObserver(function (en) { past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; upd(); }).observe(hero);
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) vis.add(x.target); else vis.delete(x.target); });
      upd();
    }, { threshold: 0.05 });
    blockers.forEach(function (b) { io.observe(b); });
  }

  function cursor() {
    var c = d.createElement('div');
    c.className = 'mx-cursor';
    c.setAttribute('aria-hidden', 'true');
    d.body.appendChild(c);
    var qx = G ? G.quickTo(c, 'x', { duration: 0.35, ease: 'power3' }) : null;
    var qy = G ? G.quickTo(c, 'y', { duration: 0.35, ease: 'power3' }) : null;
    window.addEventListener('pointermove', function (e) {
      c.classList.add('is-on');
      if (qx) { qx(e.clientX); qy(e.clientY); } else c.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)';
      var t = e.target.closest && e.target.closest('a, button, input, summary, [data-cursor]');
      c.classList.toggle('is-big', !!t);
    }, { passive: true });
    d.addEventListener('pointerleave', function () { c.classList.remove('is-on'); });
  }

  function magnetic() {
    d.addEventListener('pointermove', function (e) {
      var b = e.target.closest && e.target.closest('.mx-btn');
      if (!b) return;
      var r = b.getBoundingClientRect();
      b.style.setProperty('--px', ((e.clientX - r.left) / r.width * 100) + '%');
      b.style.setProperty('--py', ((e.clientY - r.top) / r.height * 100) + '%');
      if (G && fine && !reduce && b.hasAttribute('data-magnetic')) {
        G.to(b, { x: (e.clientX - (r.left + r.width / 2)) * 0.25, y: (e.clientY - (r.top + r.height / 2)) * 0.35, duration: 0.5, ease: 'power3.out' });
      }
    }, { passive: true });
    d.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') return; var b = e.target.closest && e.target.closest('.mx-btn'); if (!b) return; var r = b.getBoundingClientRect(); b.style.setProperty('--px', ((e.clientX - r.left) / r.width * 100) + '%'); b.style.setProperty('--py', ((e.clientY - r.top) / r.height * 100) + '%'); b.classList.add('is-tap'); clearTimeout(b.__tapT); b.__tapT = setTimeout(function () { b.classList.remove('is-tap'); }, 520); if (G && !reduce) G.fromTo(b, { scale: 0.94 }, { scale: 1, duration: 0.7, ease: 'elastic.out(1,0.45)', overwrite: 'auto' }); }, { passive: true }); d.addEventListener('pointerout', function (e) {
      var b = e.target.closest && e.target.closest('[data-magnetic]');
      if (!b || (e.relatedTarget && b.contains(e.relatedTarget))) return;
      if (G) G.to(b, { x: 0, y: 0, duration: 0.8, ease: 'elastic.out(1,0.4)' });
    });
  }

  function cart() {
    d.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mx-cart]');
      if (!b) return;
      e.preventDefault();
      var id = b.getAttribute('data-variant');
      if (!id || b.getAttribute('aria-busy') === 'true') return;
      b.setAttribute('aria-busy', 'true');
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var drawer = d.querySelector('cart-items-component[data-drawer]');
      var done = function () { b.removeAttribute('aria-busy'); };
      var toCart = function () { window.location.href = root + 'cart'; };
      var add = function (sections) {
        var body = { items: [{ id: parseInt(id, 10), quantity: 1 }] };
        if (sections) body.sections = sections;
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res && res.status) throw new Error(res.description || 'add');
          return res;
        });
      };
      var E = window.__mxEv;
      if (!drawer || !E) { add().then(toCart).catch(toCart); return; }
      var dp = E.createPromise();
      b.dispatchEvent(new E({ action: 'add', context: 'product', lines: [{ merchandiseId: id, quantity: 1 }], promise: dp.promise }));
      add(drawer.dataset.sectionId).then(function (res) {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          dp.resolve({ cart: E.createCartFromAjaxResponse(c), detail: { items: c.items, source: 'mx-buy', itemCount: 1, sections: res.sections, didError: false } });
        });
      }).then(done).catch(function (err) { dp.reject(err); done(); toCart(); });
    });
  }

  function waves() {
    var body = getComputedStyle(d.body).backgroundColor;
    var bgOf = function (sec) {
      var el = sec.querySelector('.mx') || sec.firstElementChild || sec;
      var c = getComputedStyle(el).backgroundColor;
      if (c === 'rgba(0, 0, 0, 0)' || c === 'transparent') c = getComputedStyle(sec).backgroundColor;
      return (c === 'rgba(0, 0, 0, 0)' || c === 'transparent') ? body : c;
    };
    d.querySelectorAll('.mx-how,.mx-mech,.mx-calc,.mx-gu,.mx-cta,.mx-foot').forEach(function (el) {
      var sec = el.closest('.shopify-section');
      if (!sec) return;
      var p = sec.previousElementSibling;
      while (p && (!p.classList.contains('shopify-section') || p.offsetHeight < 2)) p = p.previousElementSibling;
      if (!p) {
        var list = d.querySelectorAll('main .shopify-section');
        for (var i = list.length - 1; i >= 0; i--) { if (list[i].offsetHeight > 1 && !list[i].contains(el)) { p = list[i]; break; } }
      }
      el.style.setProperty('--wf', p ? bgOf(p) : body);
    });
  }

  function dialogs() {
    if (!lenis || !('MutationObserver' in window)) return;
    var sync = function () { if (d.querySelector('dialog[open]')) lenis.stop(); else lenis.start(); };
    var mo = new MutationObserver(sync);
    d.querySelectorAll('dialog').forEach(function (dl) { dl.setAttribute('data-lenis-prevent', ''); mo.observe(dl, { attributes: true, attributeFilter: ['open'] }); });
  }

  function progress() {
    if (!d.querySelector('[data-mx="hero"]')) return;
    var b = d.createElement('div');
    b.className = 'mx-prog';
    b.setAttribute('aria-hidden', 'true');
    d.body.appendChild(b);
    function u() {
      var h = d.documentElement.scrollHeight - window.innerHeight;
      b.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, window.scrollY / h) : 0) + ')';
    }
    window.addEventListener('scroll', u, { passive: true });
    window.addEventListener('resize', u);
    u();
  }

  function start() {
    if (hasG) {
      G.registerPlugin(ST);
      if (window.SplitText) G.registerPlugin(window.SplitText); ST.config({ ignoreMobileResize: true });
      if (!reduce && fine && window.Lenis) {
        lenis = new window.Lenis({ lerp: 0.09, smoothWheel: true, prevent: function (n) { return !!(n && n.closest && n.closest('dialog, [data-lenis-prevent]')); } });
        lenis.on('scroll', ST.update);
        G.ticker.add(function (t) { lenis.raf(t * 1000); });
        G.ticker.lagSmoothing(0);
      }
    }
    window.mxLenis = lenis;
    var kick = function () {
      html.classList.add(hasG && !reduce ? 'mx-anim' : 'mx-static');
      run(d);
      if (hasG) ST.refresh();
    };
    var wait = window.__mxIntro ? window.__mxIntro - performance.now() : 0;
    if (wait > 30) setTimeout(kick, wait); else kick();
    waves();
    dialogs();
    buy();
    cart();
    progress();
    scrollLinks();
    sticky();
    magnetic();
    if (fine && !reduce) cursor();
    if (hasG) {
      window.addEventListener('load', function () { ST.refresh(); });
      if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { ST.refresh(); });
    }
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
  d.addEventListener('shopify:section:load', function (e) { run(e.target); if (hasG) ST.refresh(); });
})();